import PropTypes from 'prop-types';

export const defaultContainerPropTypes = {
  country: PropTypes.string.isRequired,
  hasBack: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  error: PropTypes.object,
  initFlow: PropTypes.func,
  isLoading: PropTypes.bool,
};
